import { makeStyles } from '@fluentui/react-components';

// Tab shell only — the form column and jobs rail own their own styling
// (EvaluateFormColumn.style.ts / EvaluateJobsRail.style.ts).
export const useStyles = makeStyles({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '0',
    overflow: 'hidden',
  },

  // 2-column body: form column (left) + jobs rail (right).
  body: {
    flex: '1',
    display: 'flex',
    minHeight: '0',
    overflow: 'hidden',
  },
});
